import { useState, useEffect } from "react";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DefaultNavbar from "../../components/TopNavBar/DefaultNavBar";
import { 
    Typography,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Checkbox,
    Paper,
    Button
} from "@mui/material";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import unsatisfiedReq from "../../assets/requirementsJsons/unsatisfied_requirements.json";
import MDTypography from "../../components/MDTypography";
function GapsPage() {
    const [selectAll, setSelectAll] = useState(false);
    const [selectedRequirements, setSelectedRequirements] = useState({});

    const handleSelectAll = (event) => {
        const newSelectAll = event.target.checked;
        setSelectAll(newSelectAll);
        const newSelected = {};
        unsatisfiedReq.forEach((_, index) => {
            newSelected[index] = newSelectAll;
        });
        setSelectedRequirements(newSelected);
    };

    const handleSelectRequirement = (index) => {
        const newSelected = { ...selectedRequirements };
        newSelected[index] = !newSelected[index];
        setSelectedRequirements(newSelected);
        setSelectAll(Object.values(newSelected).every(value => value));
    };

    const handleExport = () => {
        // TODO: Implement export functionality
        console.log('Export clicked');
    };

    return (
        <DashboardLayout>
            <DefaultNavbar />
            <MDBox p={3} sx={{backgroundColor: "navy.main", borderRadius: 2}}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <MDTypography variant="h4">Project Gaps</MDTypography>
                    <Button
                        variant="contained"
                        startIcon={<FileDownloadIcon />}
                        onClick={handleExport}
                    >
                        Export Selected
                    </Button>
                </MDBox>
                <Paper sx={{backgroundColor: "#dee2e6"}}>
                    <TableContainer>
                        <Table stickyHeader>
                            <TableHead sx={{ display: "table-header-group", backgroundColor: "#2B5587" }}>
                                <TableRow>
                                    <TableCell padding="checkbox" sx={{ color: "text.main" }}>
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                        />
                                    </TableCell>
                                    <TableCell sx={{ color: "text.main", fontWeight: 'bold' }}>Title</TableCell>
                                    <TableCell sx={{ color: "text.main", fontWeight: 'bold' }}>Description</TableCell>
                                    <TableCell sx={{ color: "text.main", fontWeight: 'bold' }}>Rationale</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {unsatisfiedReq.map((requirement, index) => (
                                    <TableRow key={index}>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                checked={selectedRequirements[index] || false}
                                                onChange={() => handleSelectRequirement(index)}
                                            />
                                        </TableCell>
                                        <TableCell>{requirement.title}</TableCell>
                                        <TableCell>{requirement.description}</TableCell>
                                        <TableCell>{requirement.rationale}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </MDBox>
        </DashboardLayout>
    );
}

export default GapsPage;